<template>
    <div class="
      absolute bottom-[10px] left-0 flex w-full flex-col items-center justify-end

      sm:bottom-[150px]

      xl-tall:bottom-[280px]
    ">
        <div class="w-[300px]">
            <drop-down
                class="w-full !bg-white shadow-md"
                :options="items"
                :selected-value="selectedItem"
                @select="selectItem"
            />
        </div>
    </div>
</template>

<script>
    import DropDown from './UI/dropdowns/DropDown.vue';

    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        components: {
            DropDown,
        },

        computed: {
            groupPersonalization() {
                return this.customizerStore.groupPersonalization;
            },

            items() {
                const list = this.groupPersonalization.map((x, index) => ({
                    label: `${this.$t('BULK_ITEM')}${index + 1}: ${x.text}`,
                    value: index.toString(),
                    item: x,
                }));

                return list;
            },

            selectedGroupItem() {
                return this.customizerStore.selectedGroupItem;
            },

            selectedItem() {
                const index = this.groupPersonalization.indexOf(this.selectedGroupItem);

                return this.items[index]?.value;
            },
        },

        methods: {
            selectItem(v) {
                const item = this.items[+v];

                if (item) {
                    this.customizerStore.selectGroupItem(this.groupPersonalization[+v]);
                }
            },
        },
    };
</script>
